import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'GtrSecurityRegisterLayout'
})
export default class GtrSecurityRegisterLayout extends Vue {
}
